<script setup>
import { defineProps, computed, ref } from 'vue';
import VueApexCharts from "vue3-apexcharts";

const chartLabelColor = '#fff';
const chartBarColor = '#4CAF50';

const props = defineProps({
    data: {
        type: Object,
        required: true,
    },
    chartTitle: {
        type: String,
        default: null,
    },
    xAxisTitle: {
        type: String,
        default: null,
    },
    yAxisTitle: {
        type: String,
        default: null,
    },
});

let chartOptions = ref({
    chart: {
        type: "heatmap",
        zoom: {
            enabled: false
        },
        toolbar: {
            show: false
        },
        foreColor: '#898989',
    },
    colors: [chartBarColor],
    stroke: {
        width: 0,
    },
    dataLabels: {
        enabled: false,
    },
    title: {
        text: props.chartTitle || '',
        align: 'center',
        style: {
            fontSize: '14px',
            fontWeight: 'bold',
            color: chartLabelColor
        },
    },
    menu: {
        enabled: false
    },
    fill: {
        opacity: 1,
    },
    tooltip: {
        enabled: false,
    },
    xaxis: {
        axisBorder: {
            show: false,
            color: chartLabelColor,
        },
        title: {
            text: props.xAxisTitle || '',
            style: {
                color: chartLabelColor
            }
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        min: 0,
        axisBorder: {
            color: chartLabelColor,
            show: false,
        },
        axisTicks: {
            show: false,
        },
        title: {
            text: props.yAxisTitle || '',
            style: {
                color: chartLabelColor,
            },
        },
    },
    grid: {
        show: false,
        xaxis: {
            lines: {
                show: false
            }
        },
        yaxis: {
            lines: {
                show: false
            }
        },
    },
    tooltip: {
        shared: false,
        enabled: true,
        theme: "dark",
    },
    plotOptions: {
        heatmap: {
            radius: 0,
            enableShades: false,
            shadeIntensity: 1.15,
            useFillColorAsStroke: true,
            colorScale: {
                ranges: [{
                    from: 0,
                    to: 1,
                    color: '#1e5124',
                    foreColor: '#fff',
                    name: 'None',
                },
                {
                    from: 1,
                    to: 25,
                    color: '#2a5f2d',
                },
                {
                    from: 25,
                    to: 50,
                    color: '#255f28',
                },
                {
                    from: 50,
                    to: 75,
                    color: '#3a893d',
                },
                {
                    from: 75,
                    to: 999999,
                    color: '#4CAF50',
                    name: '75+',
                }],
                min: 0,
            }

        }
    },
    responsive: [{
        breakpoint: 768,
        options: {
            chart: {
                height: 300,
            },
            xaxis: {
                labels: {
                    rotate: -90,
                    style: {
                        fontSize: '9px',
                    }
                }
            }
        }
    }]
});

const shouldRender = ref(false);

const dataParsed = computed(() => {;
    return props.data;
});

</script>

<template>
    <div class="daysOfWeekChart">
        <label><input type="checkbox" v-model="shouldRender" /> Render Heatmap <em>(causes lag)</em></label>
        <VueApexCharts type="heatmap" :options="chartOptions" :series="dataParsed" v-if="shouldRender" height="450" />
    </div>
</template>

<style scoped>
.apexcharts-tooltip {
    background: #f3f3f3;
    color: orange;
}
</style>